const API_BY_HOST = {
  "eltt.lexikonn.eu": "https://eltt.lexikonn.eu/api",
  "www.eltt.lexikonn.eu": "https://eltt.lexikonn.eu/api",
  "eltt.cz": "https://eltt.cz/api",
  "www.eltt.cz": "https://eltt.cz/api",
};

export function getApiBaseUrl() {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL.replace(/\/$/, "");
  }

  if (typeof window === "undefined") {
    return "https://eltt.lexikonn.eu/api";
  }

  return API_BY_HOST[window.location.hostname] || "https://eltt.lexikonn.eu/api";
}

export const apiBaseUrl = getApiBaseUrl();
